module.exports = __webpack_public_path__ + "excell.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/excell.png
// module id = 388
// module chunks = 0